import React from "react";
import styled from "styled-components";
import Theme from "../Theme";
import { Link } from "react-router-dom";
import WirVsVirus from "./svg/WirVsVirus";

function Footer() {
  return (
    <FooterContainer>
      <LogoContainer>
        <StyledWirVsVirus />
      </LogoContainer>
      <StyledLink to="/impressum">Impressum</StyledLink>
      <StyledLink to="/datenschutz">Datenschutz</StyledLink>
    </FooterContainer>
  );
}

export default Footer;

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: row;
  padding: 2rem;
  align-items: center;
  color: ${Theme.colors.dark};
  background-color: ${Theme.colors.light};

  & > :not(:last-child) {
    margin-right: 2rem;
  }

  @media screen and (max-width: 450px) {
    flex-direction: column;
    padding: 2rem 1rem;

    & > :not(:last-child) {
      margin-right: 0rem;
      margin-bottom: 2rem;
    }
  }
`;

const LogoContainer = styled.div`
  flex-grow: 1;
`;

const StyledLink = styled(Link)`
  color: ${Theme.colors.dark};
  opacity: 0.6;
  text-decoration: none;
`;

const StyledWirVsVirus = styled(WirVsVirus)`
  height: 3rem;
`;
